import { Effect, Redacted, Schema } from "effect";
import { workerstationService } from "../../effect/service.ts";
import { privateDependencyFailure } from "../../errors/private-cause.ts";
import type { AuthorizationError, StationAuthorizationStore } from "../model.ts";

export const AuthorizationOperationError = /* @__PURE__ */ (() => {
  class AuthorizationOperationError extends privateDependencyFailure<AuthorizationOperationError>()("AuthorizationOperationError", "authorization operation") {}
  return AuthorizationOperationError;
})();
export type AuthorizationOperationError = InstanceType<typeof AuthorizationOperationError>;
export const authorizationOperationError = (cause: unknown) => new AuthorizationOperationError({ cause: Redacted.make(cause) });

export const AuthorizationServiceInvariantError = /* @__PURE__ */ (() => {
  class AuthorizationServiceInvariantError extends Schema.TaggedError<AuthorizationServiceInvariantError>()("AuthorizationServiceInvariantError", {
    reason: Schema.Literals(["entropy-length", "session-token", "browser-credentials"])
  }) {}
  return AuthorizationServiceInvariantError;
})();
export type AuthorizationServiceInvariantError = InstanceType<typeof AuthorizationServiceInvariantError>;

export type AuthorizationRepositoryOperations = {
  readonly [K in keyof StationAuthorizationStore]: (...args: Parameters<StationAuthorizationStore[K]>) =>
    Effect.Effect<Awaited<ReturnType<StationAuthorizationStore[K]>>, AuthorizationError | AuthorizationOperationError>;
};
export class AuthorizationRepository extends workerstationService<AuthorizationRepository, AuthorizationRepositoryOperations>()("Authorization/Repository") {}
